// this does not include A5-R and A5
export const SINGLE_REPORT_TYPES = ["A30", "I-PSR", "I-BAR", "SNS-E", "O-PSR", "O-BAR"] as const;
